export default __webpack_public_path__ + "static/media/sort_down.2b72aba3.svg";